import { render, staticRenderFns } from "./OrderRemark.vue?vue&type=template&id=3b328132&scoped=true"
import script from "./OrderRemark.vue?vue&type=script&lang=js"
export * from "./OrderRemark.vue?vue&type=script&lang=js"
import style0 from "./OrderRemark.vue?vue&type=style&index=0&id=3b328132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b328132",
  null
  
)

export default component.exports